import { PartialRecord } from '@tsl-frontend/tsl-utilities';

import { BadgeCode, BadgeStatus } from '../types';

export enum BadgeCopyKeys {
    TITLE = 'title',
    DESCRIPTION = 'description',
}

export const BADGE_COPY: Record<
    BadgeCode,
    PartialRecord<BadgeCopyKeys, PartialRecord<BadgeStatus, string> | string>
> = {
    [BadgeCode.FIRST_LO]: {
        [BadgeCopyKeys.TITLE]: 'First Lesson Badge',
        [BadgeCopyKeys.DESCRIPTION]: {
            [BadgeStatus.BADGE_LOCKED]:
                'You’re just one lesson away from your first badge! Let’s go!',
            [BadgeStatus.BADGE_AVAILABLE]:
                'Boom! First lesson done and badge earned! 🔥',
            [BadgeStatus.BADGE_CLAIMED]:
                'Boom! First lesson done and badge earned! 🔥',
        },
    },
    [BadgeCode.PROGRAMME_HALFWAY]: {
        [BadgeCopyKeys.TITLE]: 'Programme Halfway Badge',
        [BadgeCopyKeys.DESCRIPTION]: {
            [BadgeStatus.BADGE_LOCKED]:
                "Make it half way through your lessons and you'll earn this badge - not long to go!",
            [BadgeStatus.BADGE_AVAILABLE]:
                'You’ve smashed through the halfway point! Keep that momentum going! 💥',
            [BadgeStatus.BADGE_CLAIMED]:
                "You're halfway through your programme! Well done, you’re on a serious roll.",
        },
    },
    [BadgeCode.PROGRAMME_END]: {
        [BadgeCopyKeys.TITLE]: 'Programme End Badge',
        [BadgeCopyKeys.DESCRIPTION]: {
            [BadgeStatus.BADGE_LOCKED]:
                "You can earn this badge when you complete your final lesson of the programme. It's a big one!",
            [BadgeStatus.BADGE_AVAILABLE]:
                'Programme complete — what an achievement! You’ve earned your ultimate badge! 🎉',
            [BadgeStatus.BADGE_CLAIMED]:
                'Programme complete — what an achievement! You’ve earned your ultimate badge! 🎉',
        },
    },
};
